jQuery(function($) {

	var l_window = parseInt($(window).width());
	var header = $('#masthead'); 
  var $menu_right = $('.btn_rond_right');
    /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
    if(l_window > 1023){
      action_on_scroll();
    }
    });

    $('.btnHomeDown,.btn--ancre').click(function(e){

    var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top - 150 - 0;
  
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 600);
     
      e.preventDefault();
  });


    function action_on_scroll(){
      l_window = parseInt($(window).width());
         if ($(window).scrollTop() > 50){
            header.addClass("Masthead--sticky");
            $("body").addClass('header--sticky');
          }else{
             header.removeClass("Masthead--sticky");
             $("body").removeClass('header--sticky');
          }
        ajustement_menu_right();
   }


   function ajustement_menu_right(){
   
     var scrol_actuel =  $(window).scrollTop();
     var browserHeight = Math.round($(window).height()-100);

     $menu_right.stop().animate({
      top: Math.round(scrol_actuel+browserHeight/2),
      }, 150);

   }  

   
   /****************************************/
   /******* DIAPO DANS LES ELEMENTS FLEXIBLES *********/
   /****************************************/
    $('.gallery_js').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     // adaptiveHeight: true,
     arrows: false,
     fade: true,
     autoplay:true,
     autoplaySpeed: 4000,
     focusOnSelect: false,
     pauseOnFocus:false,
     dots:true
  });


    /****************************************/
   /******* DIAPO AUTRES SOINS *********/
   /****************************************/
    $('.SectionLinkContainer').slick({
     slidesToShow: 3,
     slidesToScroll: 3,
     // adaptiveHeight: true,
     arrows: false,
     autoplay:true,
     autoplaySpeed: 4000,
     focusOnSelect: false,
     pauseOnFocus:false,
     dots:true,
      responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
     {
      breakpoint: 380,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
  ]
  });



    



   ////////////////
   /// ACORDEON //
   // .not( "#content_s_1" )
   $('.accordion-section-content:not(.first)').hide();
   $('.FAQ-Item.first').addClass('active');
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
    // ACCORDEON SECTION 
    function close_accordion_section() {
        $('.accordeon-page .accordion-section-title').removeClass('active');
        $('.accordeon-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
        
        
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordeon-id');

        console.log(parentActiveAcc);

         $(parentActiveAcc + ' .FAQ-Item.active .FAQ-Item-Content').not(currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .FAQ-Item.active .FAQ-Item-Content').not(currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            // Open up the hidden content panel
            $('.accordeon-page ' + currentAttrValue).slideDown(300).addClass('open'); 
        }
 
        e.preventDefault();
    });
    // FIN ACCORDEON //
    ////////////////////


      /*************/
      /* On enleve le click sur a de premier niveau */
  /*************/

  $( "#primary-menu > li.menu-item-has-children > a" ).each(function( index ) {
    $( this ).attr('href', '#');
});

  $('#primary-menu > li.menu-item-has-children > a').click(function(e) {
    e.preventDefault();
  });
  

});


